(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-accordion-2"] && !Shopify.designMode) return;
  try {
      
  if (!customElements.get('accordion-item')) {
    customElements.define('accordion-item', class extends HTMLElement {
      constructor() {
        super();
        this.summary = this.querySelector('[data-summary]');
        this.content = this.querySelector('[data-content]');
        this.isAnimating = false;
      }

      connectedCallback() {
        this.summary.setAttribute('role', 'button');
        this.summary.setAttribute('aria-expanded', this.hasAttribute('open'));
        this.summary.setAttribute('tabindex', '0');
        
        this.summary.addEventListener('click', () => this.toggle());
        this.summary.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggle();
          }
        });
        
        if (this.hasAttribute('open')) {
          this.content.style.height = 'auto';
        } else {
          this.content.style.height = '0';
        }
      }

      toggle() {
        if (this.isAnimating) return;
        this.hasAttribute('open') ? this.close() : this.open();
      }

      open() {
        if (this.isAnimating) return;
        
        // Close other items in the same grid
        const parentGrid = this.closest('.section-accordion-2__grid');
        if (parentGrid) {
          parentGrid.querySelectorAll('accordion-item[open]').forEach(item => {
            if (item !== this) item.close();
          });
        }

        this.isAnimating = true;
        this.setAttribute('open', '');
        this.summary.setAttribute('aria-expanded', 'true');
        
        const height = this.content.scrollHeight;
        this.content.style.height = '0';
        this.content.getBoundingClientRect(); // Force reflow
        this.content.style.height = height + 'px';
        
        this.content.addEventListener('transitionend', () => {
          if (this.hasAttribute('open')) {
             this.content.style.height = 'auto';
          }
          this.isAnimating = false;
        }, { once: true });
      }

      close() {
        this.isAnimating = true;
        const height = this.content.scrollHeight;
        this.content.style.height = height + 'px';
        this.content.getBoundingClientRect(); // Force reflow
        this.content.style.height = '0';
        
        this.content.addEventListener('transitionend', () => {
          if (!this.hasAttribute('open')) {
             this.content.style.height = '0';
          }
          this.isAnimating = false;
        }, { once: true });
        
        this.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', 'false');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
